import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface TidioController {
	hide: () => void;
	show: () => void;
	on: (event: string, callback: () => void) => void;
}

declare global {
	interface Window {
		tidioChatApi?: TidioController;
	}
}

export const TidioController: React.FC = () => {
	const location = useLocation();

	useEffect(() => {
		const shouldHideTidio = location.pathname.toLowerCase().includes('chat');

		// Function to toggle Tidio visibility
		const toggleTidio = () => {
			if (window.tidioChatApi) {
				if (shouldHideTidio) {
					window.tidioChatApi.hide();
				} else {
					window.tidioChatApi.show();
				}
			} else {
				// If Tidio API is not ready, wait for it
				const checkTidio = () => {
					if (window.tidioChatApi) {
						if (shouldHideTidio) {
							window.tidioChatApi.hide();
						} else {
							window.tidioChatApi.show();
						}
					} else {
						// Retry after a short delay
						setTimeout(checkTidio, 100);
					}
				};
				checkTidio();
			}
		};

		// Listen for Tidio ready event if it hasn't loaded yet
		const handleTidioReady = () => {
			toggleTidio();
		};

		// Check if Tidio is already loaded
		if (document.readyState === 'complete') {
			// Page is fully loaded
			setTimeout(toggleTidio, 100);
		} else {
			// Wait for page to load
			window.addEventListener('load', () => {
				setTimeout(toggleTidio, 100);
			});
		}

		// Listen for tidioChat-ready event
		document.addEventListener('tidioChat-ready', handleTidioReady);

		// Also apply styles and body attributes for additional security
		const tidioElement = document.getElementById('tidio-chat');
		if (tidioElement) {
			if (shouldHideTidio) {
				tidioElement.style.display = 'none !important';
				tidioElement.style.visibility = 'hidden !important';
			} else {
				tidioElement.style.display = '';
				tidioElement.style.visibility = '';
			}
		}

		// Set body data attribute for CSS-based hiding
		if (shouldHideTidio) {
			document.body.setAttribute('data-hide-tidio', 'true');
		} else {
			document.body.removeAttribute('data-hide-tidio');
		}

		// Cleanup event listener and body attributes
		return () => {
			document.removeEventListener('tidioChat-ready', handleTidioReady);
			document.body.removeAttribute('data-hide-tidio');
		};
	}, [location.pathname]);

	return null; // This component doesn't render anything
}; 